import styled from 'styled-components';

interface LayerWrapperProps {
  $zIndex?: number;
  $translateZ?: number;
  $borderRadius?: number;
}

const BaseLayerWrapper = styled.div<LayerWrapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  will-change: transform;

  ${({ $zIndex }) => $zIndex !== undefined && `z-index: ${$zIndex};`}
  ${({ $translateZ }) => $translateZ !== undefined && `transform: translateZ(${$translateZ}px);`}
`;

const DigitalCardLayerStyled = {
  BaseLayerWrapper,
};

export default DigitalCardLayerStyled;
